import React from 'react';
import { styled } from '@compiled/react';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { Section, SkeletonItem } from '@atlaskit/side-navigation';
import { token } from '@atlaskit/tokens';
import type { SidebarSkeletonItemProps } from './types.tsx';

export const Skeleton = ({ isFull = false }: SidebarSkeletonItemProps): React.JSX.Element => (
	<UFOLoadHold name="sidebar-skeleton">
		<BackgroundedWrapper>
			{isFull && (
				<HeadingWrapper>
					<SkeletonItem hasIcon />
				</HeadingWrapper>
			)}
			<Section>
				<SkeletonItem hasIcon={isFull} />
				<SkeletonItem hasIcon={isFull} />
				<SkeletonItem hasIcon={isFull} />
				<SkeletonItem hasIcon={isFull} />
				<SkeletonItem hasIcon={isFull} />
			</Section>
		</BackgroundedWrapper>
	</UFOLoadHold>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BackgroundedWrapper = styled.div({
	height: 'calc(100% - 15vh)',
	paddingTop: 0,
	paddingRight: token('space.300'),
	paddingBottom: 0,
	paddingLeft: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeadingWrapper = styled.div({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingTop: '28px',
	paddingRight: 0,
	paddingBottom: token('space.200'),
	paddingLeft: 0,
});
